import type { ReactNode } from "react";

import { cn } from "@/lib/utils";
import { NvLockLineIcon } from "./nv-icons-finder";

// 비회원 로그인 유도 (Figma ver.7 "로그인 유도", 10/13 제안 21): 행마다 반복하던 "상세는 이용 권한 필요" 대신 영역마다 한 번만.
// - card: 흐린 영역 위에 얹는 흰 카드 (HOME 주목받는 · Top 10, Finder 추천 결과 · 주목받는 패널) — 그림자 0 4 16 / 8%
// - banner: 목록 맨 위에 두는 주황 띠 (HOME Certified Agents)

function LoginButton({ onLogin }: { onLogin: () => void }) {
  return (
    <button
      type="button"
      onClick={onLogin}
      className="inline-flex h-[34px] shrink-0 items-center justify-center rounded-nv-chip bg-nv-brand px-4 text-[13px] font-bold leading-4 text-nv-text-inverse focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-nv-brand focus-visible:ring-offset-2"
    >
      로그인
    </button>
  );
}

export interface NvLoginPromptProps {
  children: ReactNode;
  onLogin: () => void;
  variant?: "card" | "banner";
  className?: string;
}

export function NvLoginPrompt({ children, onLogin, variant = "card", className }: NvLoginPromptProps) {
  if (variant === "banner") {
    return (
      <div className={cn("flex items-center justify-between gap-3 rounded-[10px] bg-nv-brand-subtle px-4 py-[10px]", className)}>
        <p className="flex min-w-0 items-center gap-2 text-[13px] font-medium leading-4 text-nv-text-primary">
          <NvLockLineIcon size={16} className="shrink-0 text-nv-text-secondary" />
          {children}
        </p>
        <LoginButton onLogin={onLogin} />
      </div>
    );
  }
  return (
    <div
      className={cn(
        "inline-flex items-center gap-3 rounded-nv-card border border-[#E3E5E8] bg-nv-surface px-[18px] py-3 shadow-[0_4px_16px_rgba(0,0,0,0.08)]",
        className,
      )}
    >
      <NvLockLineIcon size={16} className="shrink-0 text-nv-text-secondary" />
      <p className="text-[14px] font-medium leading-[17px] text-nv-text-primary">{children}</p>
      <LoginButton onLogin={onLogin} />
    </div>
  );
}
